import { useEffect, useState } from "react";
import ToolTip from "../Tooltip/Tooltip";
import "./ToggleButton.css";

const ToggleButton = ({
	defaultChecked,
	selected,
	onChange,
	onClick,
	disabled,
	hidden,
	label,
	tooltipText,
	tooltipVisible,
	style,
	className,
}) => {
	const initialActive =
		defaultChecked !== undefined ? defaultChecked : selected || false;
	const [active, setActive] = useState(initialActive);

	useEffect(() => {
		if (selected !== undefined) {
			setActive(selected);
		}
	}, [selected]);

	const toggle = () => {
		if (disabled) return;
		const newState = !active;
		setActive(newState);
		if (onChange) onChange({ target: { checked: newState } });
		if (onClick) onClick(newState);
	};

	return (
		<div
			className={`toggle-container ${disabled ? "disabled" : ""} ${className}`}
			style={{ display: hidden ? "none" : "inline-flex", ...style }}
			onClick={toggle}
		>
			<div className={`toggle-switch ${active ? "active" : ""}`} />
			<div className="toggle-label-container">
				<span className="toggle-label">{label}</span>
				{tooltipVisible && (
					<ToolTip tooltipText={tooltipText} tooltipVisible={tooltipVisible} />
				)}
			</div>
		</div>
	);
};

export default ToggleButton;
